import { createReducer, on } from '@ngrx/store';
import * as ProviderActions from './provider.actions';
import { Provider } from '../../interfaces/provider.interface';
import { ResetAllStores } from '../app/app.actions';


export interface ProviderState {
  loading: boolean;          // for lists & registration
  loadingProviderById: boolean; // for loading single provider by ID
  providers: Provider[];
  provider: Provider | null;
  response: any | null;
  error: string | null;
  providerByIdError: string | null;
}


export const initialState: ProviderState = {
  loading: false,
  loadingProviderById: false,
providerByIdError: null,
  providers: [],
  provider: null,
  response: null,
  error: null,
};


export const providerReducer = createReducer(
  initialState,

  // Register Super Admin
  on(ProviderActions.registerSuperAdmin, (state) => ({ ...state, loading: true })),
  on(ProviderActions.registerSuperAdminSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
  })),
  on(ProviderActions.registerSuperAdminFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load All Providers
  on(ProviderActions.loadAllProviders, (state) => ({ ...state, loading: true })),
  on(ProviderActions.loadAllProvidersSuccess, (state, { providers }) => ({
    ...state,
    loading: false,
    providers,
  })),
  on(ProviderActions.loadAllProvidersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load By ID
on(ProviderActions.loadProviderById, (state) => ({
  ...state,
  loadingProviderById: true,
  providerByIdError: null,
  provider: null
})),

on(ProviderActions.loadProviderByIdSuccess, (state, { provider }) => ({
  ...state,
  loadingProviderById: false,
  provider,
})),

on(ProviderActions.loadProviderByIdFailure, (state, { error }) => ({
  ...state,
  loadingProviderById: false,
  providerByIdError: error,
  provider: null
})),
on(ProviderActions.clearLoadedProvider, (state) => ({
  ...state,
  provider: null,
  loadingProviderById: false,
  providerByIdError: null
})),



  // Delete
  on(ProviderActions.deleteProviderById, (state) => ({ ...state, loading: true })),
  on(ProviderActions.deleteProviderByIdSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
  })),
  on(ProviderActions.deleteProviderByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ResetAllStores, () => initialState),

);
